import type { PropertyDetailListing } from '@/src/components/features/property/types';

type CompetitionListing = PropertyDetailListing & {
  popularity?: {
    summary?: {
      viewed?: number;
      inquiries?: number;
    };
    lastContacted?: {
      ago?: string;
    };
  };
};

export type CompetitionDisplay = {
  viewed: number;
  inquiries: number;
  lastContactedAgo?: string;
  isActive: boolean;
};

export const getCompetitionDisplay = (listing: PropertyDetailListing | null | undefined): CompetitionDisplay | null => {
  if (!listing || (listing.active === false && listing.isAllowedToRetain === false)) return null;

  const competitionListing = listing as CompetitionListing;
  const viewed = competitionListing.popularity?.summary?.viewed ?? 0;
  if (viewed <= 0) return null;

  return {
    viewed,
    inquiries: competitionListing.popularity?.summary?.inquiries ?? 0,
    lastContactedAgo: competitionListing.popularity?.lastContacted?.ago,
    isActive: listing.active !== false,
  };
};
